export default __webpack_public_path__ + "static/media/not-found.7d017534.svg";